export default __webpack_public_path__ + "static/media/Home-Default.b6cdcec9.svg";